import { createInjectionKey } from "../../_utils/index.mjs";
export const popselectInjectionKey = createInjectionKey('n-popselect');